import React, { useState, useEffect } from 'react';
import moment from 'moment';
import {
  Form,
  Input,
  Button,
  Radio,
  DatePicker,
  Select,
  NumberPicker,
  Notification,
  Checkbox,
} from '@alifd/next';
import LzMessage from '@/components/common/LzMessage';
import styles from './index.module.scss';

const formItemLayout = {
  labelCol: { fixedSpan: 6 },
};

const loopTypeList = [
  // 循环方式
  {
    value: 1,
    label: '单次执行',
  },
  {
    value: 2,
    label: '循环执行',
  },
];

const executionFrequency = [
  {
    value: 1,
    label: '按天',
  },
  {
    value: 2,
    label: '按周',
  },
  {
    value: 3,
    label: '按月',
  },
];

const weekList = [
  {
    value: 1,
    label: '周日',
  },
  {
    value: 2,
    label: '周一',
  },
  {
    value: 3,
    label: '周二',
  },
  {
    value: 4,
    label: '周三',
  },
  {
    value: 5,
    label: '周四',
  },
  {
    value: 6,
    label: '周五',
  },
  {
    value: 7,
    label: '周六',
  },
];

const CreateActivity = ({ canvasFormdata = {}, cancelFunc = {} }) => {
  // 父组件接收的值的缓存区
  const [formdata, setFormData] = useState({
    campaignName: '', // 活动名
    campaignRemark: '', // 备注
    executionPlan: {
      type: 1, // 循环方式 1-单次 2-循环
      startTime: 0, // 循环执行周期，需为时间戳
      endTime: 0,
      frequencyType: 1, // 循环执行频率： 1-按天 2-按周 3-按月
      frequencyValue: 1, // 执行频率下的周期： 按天，按月就是字面量，按周等于∑2的n次幂
      startHour: 2, // 循环执行起始时间点 小时
      startMinute: 0, // 循环执行起始时间点 分
      timeDifference: 0, // 立即执行 1 定时执行
    },
  });
  // 执行起始时间点的列表需要自己计算出来
  // const [hourList, setHourList] = useState([{
  //   label: '8',
  //   value: '8'
  // }]);

  /**
   * 循环执行选择执行频率
   */
  // const executionPeriod = () => {
  //   let hoursList = [...hourList];
  //   for(let i = 8; i < 24; i++) {
  //     hoursList.push({
  //       label: i + '',
  //       value: i + ''
  //     })
  //   }
  //   setHourList(hoursList);
  // };

  /**
   * 计算出循环执行时的执行起始时间点小时列表，初始化父组件传过来的值
   */
  useEffect(() => {
    // executionPeriod();
    const formDatas = JSON.parse(JSON.stringify(canvasFormdata));
    let cont = formDatas.campaignRemark ? formDatas.campaignRemark : '';
    cont = cont?.replace(/\n/g, '<br/>');
    cont = cont?.replace(/\s/g, '&nbsp;');
    formDatas.campaignRemark = cont;
    // 如果执行频率为 周，需要把frequencyValue拆分为数组进行反向赋值
    if (formDatas.executionPlan.frequencyType === 2) {
      const x = JSON.parse(
        JSON.stringify(formDatas.executionPlan.frequencyValue)
      );
      const binaryStringValue = x.toString(2);
      const result = [];
      const length = binaryStringValue.length - 1;
      for (let i = length; i >= 0; i--) {
        const c = binaryStringValue.charAt(i);
        if (c == '1') {
          result.push(length - i);
        }
      }
      formDatas.executionPlan.frequencyValue = result;
    }
    setFormData({ ...formDatas });
  }, []);

  return (
    <div>
      <Form
        {...formItemLayout}
        className={`${styles.createActivityRoot} canvasDialog ${styles.loopRadio} ${styles['activity-detail']}`}
      >
        <Form.Item label="活动名称：">
          <div className={styles['activity-detail-content']}>
            {formdata.campaignName}
          </div>
        </Form.Item>
        {/* <Form.Item label="循环方式：">
          <div className={styles['activity-detail-content']}>
            {loopTypeList[formdata.executionPlan.type - 1].label}
          </div>
        </Form.Item> */}
        {/* 循环方式：单次执行的执行时间展示 (timeDifference: 0 立即执行  timeDifference：1 指定时间)*/}
        {formdata.executionPlan.type === 1 &&
          <Form.Item label="执行时间：">
            <div className={styles['activity-detail-content']}>
              {formdata.executionPlan.timeDifference === 1 ? moment(formdata.executionPlan.crowdStartTime).format('YYYY-MM-DD HH:mm:ss') : '立即执行'}
            </div>
          </Form.Item>
        }
        {/* 循环方式：循环执行的执行时间展示(展示三个部分：执行周期、执行频率、执行起始时间点) */}
        {formdata.executionPlan.type === 2 && (
          <>
            <Form.Item label="执行周期：" >
              <div className={styles['activity-detail-content']}>
                {moment(formdata.executionPlan.startTime).format('YYYY-MM-DD')}{' '}
                至 {moment(formdata.executionPlan.endTime).format('YYYY-MM-DD')}
              </div>
            </Form.Item>
            <Form.Item label="执行频率：">
              <div
                className={`${styles.displayFlex} formItemWidth ${styles['activity-detail-content']}`}
              >
                {formdata.executionPlan.frequencyType === 1 && (
                  <div style={{ marginLeft: '5px' }}>
                    每{formdata.executionPlan.frequencyValue}日，执行
                  </div>
                )}
                {formdata.executionPlan.frequencyType === 3 && (
                  <div style={{ marginLeft: '5px' }}>
                    每月{formdata.executionPlan.frequencyValue}日，执行
                  </div>
                )}
              </div>
              {formdata.executionPlan.frequencyType === 2 && (
                <div className={styles['activity-detail-content']}>
                  每
                  <Checkbox.Group
                    direction="hoz"
                    value={formdata.executionPlan.frequencyValue}
                    onChange={(val) =>
                      setFormData({
                        ...formdata,
                        executionPlan: {
                          ...formdata.executionPlan,
                          frequencyValue: val,
                        },
                      })
                    }
                  >
                    {weekList.map((i, index) => (
                      <Checkbox disabled value={i.value} key={i.value}>
                        {i.label}
                      </Checkbox>
                    ))}
                  </Checkbox.Group>
                  执行
                </div>
              )}
            </Form.Item>
            <Form.Item label="执行起始时间点：">
              <div
                className={`${styles['activity-detail-content']} formItemWidth`}
              >
                {formdata.executionPlan.startHour}点
                {formdata.executionPlan.startMinute}分
                {/* {
                      formdata.executionPlan.startHour === 2 ? '凌晨02:00' : '下午14:00'
                    } */}
              </div>
            </Form.Item>
          </>
        )}
        <Form.Item
          label="备注："
          className={`customActivityRemark ${styles['activity-detail-content']}`}
          style={{
            margin: '15px 0',
          }}
        >
          <div
            className={styles['activity-detail-content']}
            style={{ wordBreak: 'break-word' }}
            dangerouslySetInnerHTML={{ __html: formdata.campaignRemark }}
          />
        </Form.Item>
      </Form>
      <div className={styles.footer}>
        <Button
          type="primary"
          className={`cancel-btn ${styles.w88}`}
          onClick={cancelFunc}
        >
          确认
        </Button>
      </div>
    </div>
  );
};
export default CreateActivity;
